import {
  useCreateMissionMutation,
  useGetMissionsQuery
} from '@bo-services/promotionsApi';
import { useMemo, useState } from 'react';

export const useMissions = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [, setSelectedMissionId] = useState<string>('');

  const {
    data: missionsData,
    isLoading: isLoadingMissions,
    isFetching: isFetchingMissions
  } = useGetMissionsQuery({
    page: currentPage
  });

  const [createMission] = useCreateMissionMutation();

  const missionsContext = useMemo(() => {
    return {
      createMission,
      filters: {
        currentPage,
        onCurrentPageChange: setCurrentPage
      },
      isMissionsRequestLoading: isLoadingMissions || isFetchingMissions,
      onSelectedMissionId: setSelectedMissionId,
      selectedMissionData: undefined,
      missionsData
    };
  }, [
    createMission,
    currentPage,
    isLoadingMissions,
    isFetchingMissions,
    missionsData
  ]);

  return { missionsContext };
};
